/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AdminStatusDto = {
    OnHoldAdmin: 'ON_HOLD_ADMIN',
    OnHoldConditional: 'ON_HOLD_CONDITIONAL',
    None: 'NONE'
} as const;

export type AdminStatusDto = typeof AdminStatusDto[keyof typeof AdminStatusDto];



